module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_1-19e9a366a4b59bd647048df69238bfd2.jpg";